import React from "react";
import { Link } from "react-router-dom";

import SidebarContent from "./SidebarContent";
import logo from "../../assets/images/logo.png";


const Sidebar = (props: any) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt=" "height="30"/>
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="50"  style={{marginLeft: "100%", marginTop: "20px"}} />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;